import { useState } from "react"
import styled from "styled-components"

import { type ReactChild } from "#customTypes/globalTypes"

const SAccordionButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  transition: all 0.2s ease;

  &:hover {
    background: #e6f7ff;
    border-color: #1890ff;
  }

  &:focus {
    outline: none;
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`

const SArrow = styled.span<{ $isOpen: boolean }>`
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #666;
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "rotate(0deg)")};
`

const SContent = styled.div`
  margin-top: 8px;
`

const Accordion = ({
  children,
  trigger = "Click me",
  onClick,
  isOpen,
}: {
  children: ReactChild
  trigger?: ReactChild
  onClick?: () => void
  isOpen?: boolean
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(isOpen ?? false)

  const handleClick = () => {
    if (isOpen === undefined) {
      setIsAccordionOpen(!isAccordionOpen)
    }
    onClick?.()
  }

  const currentlyOpen = isOpen ?? isAccordionOpen

  return (
    <>
      <SAccordionButton onClick={handleClick}>
        <span>{trigger}</span>
        <SArrow $isOpen={currentlyOpen} />
      </SAccordionButton>
      {currentlyOpen && <SContent>{children}</SContent>}
    </>
  )
}

export default Accordion
